<div class="row"
     style="margin-top: 10px">
    <!--	Контейнер с проперти start    -->
    <div class="col-6 list-group">
        <h2>{{ 'PROPERTIES.CONNECTED' | translate }}</h2>
        <div (cdkDropListDropped)="updateAfterDrag($event)"
             cdkDropList
             class="drag_container">
            <div *ngIf="!targetProperties.length"
                 class="list-group-item list-group-item-action"
            >
                {{ 'EMPTY_LISTS.EMPTY' | translate }}
            </div>
            <div *ngFor="let prop of targetProperties; let i = index"
                 [attr.data-index-target-prop]="i"
                 [cdkDragBoundary]="'.drag_container'"
                 [cdkDragData]="prop"
                 [cdkDragStartDelay]="100"
                 [class.text-danger]="['property_catalog', 'property_todo'].includes(prop.property.property_type) &&
                                        !prop.property.property_type_target"
                 [ngbTooltip]="['property_catalog', 'property_todo'].includes(prop.property.property_type) &&
                                !prop.property.property_type_target ? ('PROPERTIES.CATALOG_DELETED' | translate) : ''"
                 cdkDrag
                 class="list-group-item list-group-item-action justify-content-between"
                 style="display: flex; align-items: center; cursor: grab"
            >
                <div class="flex-display align-items-center">
                    <i class="bi bi-justify"
                       style="font-size: 36px"></i>

                    <i (click)="changeView(prop)"
                       [class]="prop.default_view ? 'bi bi-eye pointer text-success' : 'bi bi-eye-slash pointer text-secondary'"
                       [ngbTooltip]="(prop.default_view ? 'PROPERTIES.HIDE' : 'PROPERTIES.SHOW') | translate "
                       style="font-size: 24px"
                    ></i>
                    <i [class]="propertyIcon[prop.property.property_type].icon"
                       [ngbTooltip]="'PROPERTIES.TOOLTIPS.' + propertyIcon[prop.property.property_type].tooltip | translate"
                    ></i>
                    <div>
                        <span>{{ prop.property.title }}
                            <i *ngIf="prop.property.is_multiform"
                               class="bi bi-ui-checks ms-2"
                               ngbTooltip="{{ 'PROPERTIES.MULTIPLE' | translate }}"
                            ></i>
                        </span>
                        <span *ngIf="['property_member', 'property_catalog', 'property_todo'].includes(prop.property.property_type)">
							<br>{{ 'PROPERTIES.ACCESS.ACCESS' | translate }}: {{
                                prop.property.property_type === 'property_member' ?
                                    ('PROPERTIES.ACCESS.' + prop.property.property_type_target | translate) :
                                    prop.property.property_type_target ? prop.property.property_type_target :
                                        ('PROPERTIES.ACCESS.denied' | translate)
                            }}
						</span>
                    </div>
                </div>
                <div>
                    <i (click)="deleteProp(prop)"
                       class="bi bi-trash text-danger"
                       ngbTooltip="{{ 'BUTTON_TEXT.DELETE' | translate }}"
                    ></i>
                </div>
            </div>
        </div>
    </div>
    <!--	Контейнер с добавленными проперти end    -->

    <!--	Контейнер с общими проперти start    -->
    <div class="col-6">
        <h2>{{ 'PROPERTIES.AVAILABLE' | translate }}</h2>
        <div *ngFor="let key of keys"
             [attr.data-prop-key]="key"
             class="list-group"
             style="margin-bottom: 10px"
        >
            <h4>
                <i [class]="propertyIcon[key].icon"></i>
                {{ 'PROPERTIES.GROUPS.' + propertyTextTemplate[key].key | translate }}
            </h4>

            <div (click)="propertyTextTemplate[key].isShow = !propertyTextTemplate[key].isShow"
                 class="list-group-item list-group-item-action"
                 style="cursor: pointer;">
                <h5>
                    <i [class]="propertyTextTemplate[key].isShow ? 'bi bi-caret-down' : 'bi bi-caret-right-fill'"></i>
                    {{ (propertyTextTemplate[key].isShow ? 'PROPERTIES.HIDE' : 'PROPERTIES.SHOW') | translate }}
                </h5>

            </div>

            <ng-container *ngIf="propertyTextTemplate[key].isShow" class="list-group">
                <div *ngIf="!allProperties[key].length"
                     class="list-group-item list-group-item-action"
                >
                    <i class="text-secondary">{{ 'EMPTY_LISTS.PROPERTIES.' + propertyTextTemplate[key].key | translate }}</i>
                </div>
                <div *ngFor="let prop of allProperties[key]; let i = index"
                     [attr.data-all-prop]="i"
                     [class.disabled]="['property_catalog', 'property_todo'].includes(prop.property_type) && !prop.property_type_target"
                     [class.text-danger]="['property_catalog', 'property_todo'].includes(prop.property_type) && !prop.property_type_target"
                     class="list-group-item list-group-item-action"
                     style="display: flex; align-items: center"
                >
                    <i (click)="addProperty(prop)"
                       [class.bg-info]="['property_catalog', 'property_todo'].includes(prop.property_type) && !prop.property_type_target"
                       class="bi bi-arrow-left-square pointer bg-success text-light"
                       ngbTooltip="{{ 'PROPERTIES.ADD' | translate }}"
                       style="font-size: 22px"
                    ></i>
                    <i [class]="propertyIcon[prop.property_type].icon"
                       [ngbTooltip]="propertyIcon[prop.property_type].tooltip"
                    ></i>
                    <div>
                    <span>
                        {{ prop.title }}
                        <i *ngIf="prop.is_multiform"
                           class="bi bi-ui-checks ms-2"
                           ngbTooltip="{{ 'PROPERTIES.MULTIPLE' | translate }}"
                        ></i>
                    </span>
                        <span *ngIf="['property_member', 'property_catalog', 'property_todo'].includes(prop.property_type)">
							<br>{{ 'PROPERTIES.ACCESS.ACCESS' | translate }}: {{
                                prop.property_type === 'property_member' ?
                                    ('PROPERTIES.ACCESS.' + prop.property_type_target | translate) :
                                    prop.property_type_target ? prop.property_type_target : ('PROPERTIES.ACCESS.denied' | translate)
                            }}
					</span>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <!--	Контейнер со всеми проперти end    -->
</div>
